import { Component } from "../core/Component";
import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { Wall } from "./Wall";

export class DestroyInWall extends Component {
	
	scene: GameScene;
	offset = 250;

	constructor(obj: GameObject, offset?: number) {
		super(obj);
		if (offset) this.offset = offset;
	}

	public update(_dt: number): void {
		const obj = this.obj;
		const wall = this.scene.objects.find(o => o instanceof Wall);
		if (wall && obj.x - this.offset > wall.x - wall.width / 2 && obj.x + this.offset < wall.x + wall.width / 2) {
			obj.destroy();
		}
	}

}